import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { CreateTicketPayload, UploadAttachmentsPayload } from "../../@core/models/model";

@Injectable({ providedIn: 'root' })
export class SupportTicketService extends BaseService {

    constructor(protected override http: HttpClient) {
        super(http);
    }

    private apiUrl = environment.apiUrl + '/support-ticket';

    createTicket(payload: CreateTicketPayload) {
        return this.post<{ issueKey: string }>(this.apiUrl + '/create', payload);
    }

    uploadAttachments(payload: UploadAttachmentsPayload) {
        const form = new FormData();
        form.append('issueKey', payload.issueKey);
        payload.files.forEach(file => {
            form.append('attachments', file);
        });
        return this.post(this.apiUrl + '/upload-attachments', form);
    }

    sendSupportTicketEmailToCustomer(email: string, ticketID: string, name: string, description: string, title: string) {
        return this.post(this.apiUrl + '/send-support-ticket-email-to-customer', { email, ticketID, name, description, title });
    }
}